/** @jsxImportSource @emotion/react */

import Panels from 'src/components/Panel/Panels';
import ClientsListPanel from './ClientListPanel';

export default function Clients() {
  return <Panels main={ClientsListPanel} />;
}
